import React from 'react'
import { useSelector } from 'react-redux'

import { OrderFields } from 'types/order'

import { selectOrderRead } from 'store/order/order.selectors'

import TextWithPrefix from 'components/atoms/TextWithPrefix'
import Title from 'components/atoms/Title'
import PhoneNumberLink from 'components/atoms/PhoneNumberLink'

const Customer: React.FC = () => {
  const form = useSelector(selectOrderRead)

  return (
    <>
      <ul className="list-group row needs-validation">
        <li className="list-group-item">
          <Title text="Контакты" />
          <div className="p-0">
            <TextWithPrefix text={form[OrderFields.LOGISTIC_FIO]} prefix="Контакт:" />
            <TextWithPrefix text={<PhoneNumberLink phone={form[OrderFields.LOGISTIC_TEL]} />} prefix="Телефон 1:" />
            <TextWithPrefix text={<PhoneNumberLink phone={form[OrderFields.LOGISTIC_TEL_2]} />} prefix="Телефон 2:" />
            <TextWithPrefix text={form[OrderFields.CARRIER_EMAIL]} prefix="Email:" />
          </div>
        </li>
      </ul>
    </>
  )
}

export default Customer
